/* __next_internal_client_entry_do_not_use__ rotate,dash,SVG,Circle,PageLoader,CircleSpinner,default auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingSpinner as SlateLoadingSpinner } from "@faire/web--source/slate/LoadingSpinner";
import * as React from "react";
import styled, { keyframes } from "styled-components";
export var rotate = keyframes([
    "100%{transform:rotate(360deg);}"
]);
export var dash = keyframes([
    "0%{stroke-dasharray:1,200;stroke-dashoffset:0;}50%{stroke-dasharray:89,200;stroke-dashoffset:-35px;}100%{stroke-dasharray:89,200;stroke-dashoffset:-124px;}"
]);
export var SVG = styled.svg.withConfig({
    componentId: "sc-d8c91320-0"
})([
    "animation:",
    " 2s linear infinite;transform-origin:center center;"
], rotate);
export var Circle = styled.circle.withConfig({
    componentId: "sc-d8c91320-1"
})([
    "stroke-dasharray:1,200;stroke-dashoffset:0;animation:",
    " 1.5s ease-in-out infinite;stroke-linecap:round;"
], dash);
var Wrapper = styled.div.withConfig({
    componentId: "sc-d8c91320-2"
})([
    "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);"
]);
export var PageLoader = function(param) {
    var dataTestId = param["data-test-id"];
    return /*#__PURE__*/ _jsx(Wrapper, {
        children: /*#__PURE__*/ _jsx(SlateLoadingSpinner, {
            "data-test-id": dataTestId
        })
    });
};
/**
 * @deprecated use LoadingSpinner
 * @trackcomponent
 * @supersededBy "@faire/web--source/slate/LoadingSpinner/LoadingSpinner#LoadingSpinner"
 **/ export var CircleSpinner = function(param) {
    var _param_color = param.color, color = _param_color === void 0 ? "#333" : _param_color, _param_stroke = param.stroke, stroke = _param_stroke === void 0 ? 2 : _param_stroke, _param_size = param.size, size = _param_size === void 0 ? "100%" : _param_size, width = param.width, height = param.height, className = param.className, dataTestId = param["data-test-id"];
    return /*#__PURE__*/ _jsx(SVG, {
        viewBox: "25 25 50 50",
        width: width || size,
        height: height || size,
        className: className,
        "data-test-id": dataTestId,
        children: /*#__PURE__*/ _jsx(Circle, {
            cx: "50",
            cy: "50",
            r: "20",
            stroke: color,
            fill: "none",
            strokeWidth: stroke,
            strokeMiterlimit: "10"
        })
    });
};
/** @deprecated use LoadingSpinner */ export default CircleSpinner;
